module.exports = __webpack_public_path__ + "static/media/BANNERSTANLEYBET.b11c8372.png";